function insertSliderValues () {
    const slider = document.querySelector("[id$=DrivingExperienceUAENew]");
    const slider2 = document.querySelector("[id$=DrivingExperienceInternationalNew]")

    if(slider) {
        setTimeout(() => {
            const firstValue = slider.querySelector(".rc-slider .rc-slider-mark .rc-slider-mark-text");
            const firstValue2 = slider2.querySelector(".rc-slider .rc-slider-mark .rc-slider-mark-text");
            for(var i=5; i > 0; i--) {
                firstValue.insertAdjacentHTML('afterend', `<span class="rc-slider-mark-text value-${i}">${i}</span>`);
                firstValue2.insertAdjacentHTML('afterend', `<span class="rc-slider-mark-text value-${i}">${i}</span>`);
            }
        },750)
    }
}

export { insertSliderValues };